export default __webpack_public_path__ + "assets/insets9.png";